import hover from './hover';
import transition from './transition';
import scroll from './scroll';

export default class conceptManager {
    constructor(manager) {

        //manager
        this.manager = manager;
        this.hover = new hover(this.manager,this); //一覧のホバー動作
        this.transition = new transition(this.manager,this); //ページ遷移動作
        this.scroll = new scroll(this.manager,this); //ページタイトル消す、写真複数の時に写真の切替え

        //dom
        this.$title = document.getElementById('l-lowlayer__title');
        //一覧
        this.$linkWrap = document.getElementById('p-concept__list');
        this.$linkList = document.querySelectorAll('.p-concept__list');
        //詳細
        this.$photo = document.getElementById('l-lowlayer__photo');
        this.$photoList = document.querySelectorAll('#l-lowlayer__photo .image');
        this.$waku = document.querySelector('#l-lowlayer__photo .waku');
        this.$detail = document.getElementById('p-concept__detail');
        //header
        this.$headerNavi = document.getElementById("l-header__navi");

        //status
        this.status = {
            motion:false,
            current:99,
            point:[],
            titlePoint:0,
            titleFlg:false,
        }

    }
    init(){

        // ------------ spの時fixedフッターを非表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer', .6 ,{
                opacity:0,
                ease: Power2.easeOut,
            });
        }

        //set
        if(document.body.id == 'concept'){ //一覧はこちら
            // ------------ 左のスクロールを促すアイコンを表示
            this.manager.scrollIcon.show();
            this.transition.init();
            this.transition.in();
            this.hover.init();
            this.manager.color.set('black','black','black','black',1);
        }else{
            // ------------ 左のスクロールを促すアイコンを非表示
            this.manager.scrollIcon.hide();
            this.transition.detailIn(); //詳細はこちら
            if(this.$photoList.length > 1) this.scroll.resizeDetail();
            this.manager.color.set('black','black','black','black',0);
            let _url = location.href;
            if(this.manager.param.displayType != 'sp' && _url.indexOf('/04/') != -1 && !(this.manager.isIpad && this.manager.portrait)){
                this.manager.color.set('white','black','white','black',0);
            }
        }

        // ------------ 初期表示時Headerを必ず表示
        TweenMax.to(this.$headerNavi, .6 ,{
            opacity:1,
            ease: Power2.easeOut,
        });

    }
    render(){

        if(this.$title) this.scroll.renderIndex();
        if(this.$photoList.length > 1) this.scroll.renderDetail();

    }
    resize(){

        if(this.$title) this.scroll.resizeIndex();
        if(this.$photoList.length > 1) this.scroll.resizeDetail();

    }
}